import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface Props{
  title: string; 
  subTitle: string; 
}

const SigninHeader = ({ title, subTitle }: Props) => {
  return (
    <Box>
    <Typography sx={{textAlign: {xs: "center",md: "left"}}}>
    <Link to="/">
        <img
          src={"/logo.png"}
          alt={"logo_full"}
          style={{ width: 90, height: 65 }}
        />
      </Link>
    </Typography>
      <Typography
        color="primary"
        sx={{
          fontSize: 24,
          fontWeight: 600,
          color: "#383e4f"
        }}
        mt={6}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: 13,
          color: "#9BA69C",
          mb: 4,
        }}
        mr={6}
      >
        {subTitle}
      </Typography>
    </Box>
  );
};

export default SigninHeader;
